import type { ThemeAccent, ThemeMode } from '@appTypes/common.types';

export const THEME_MODES: ThemeMode[] = [
  'light',
  'dark',
  'lightOrange',
  'lightSky',
  'lightRose',
  'darkOrange',
  'darkSky',
  'darkRose',
];

export function isThemeMode(value: string): value is ThemeMode {
  return (THEME_MODES as readonly string[]).includes(value);
}

export function normalizeThemeMode(stored: unknown): ThemeMode {
  if (typeof stored !== 'string' || !isThemeMode(stored)) {
    return 'light';
  }
  return stored;
}

export const THEME_TOGGLE_PAIR: Record<ThemeMode, ThemeMode> = {
  light: 'dark',
  dark: 'light',
  lightOrange: 'darkOrange',
  darkOrange: 'lightOrange',
  lightSky: 'darkSky',
  darkSky: 'lightSky',
  lightRose: 'darkRose',
  darkRose: 'lightRose',
};

export function themeModeIsDark(mode: ThemeMode): boolean {
  return mode === 'dark' || mode === 'darkOrange' || mode === 'darkSky' || mode === 'darkRose';
}

export function getAccentForMode(mode: ThemeMode): ThemeAccent {
  if (mode === 'light' || mode === 'dark') return 'blue';
  if (mode.endsWith('Orange')) return 'orange';
  if (mode.endsWith('Sky')) return 'sky';
  return 'rose';
}

export const THEME_MODE_LABELS: Record<ThemeMode, string> = {
  light: 'Light (blue)',
  dark: 'Dark (blue)',
  lightOrange: 'Light (orange)',
  lightSky: 'Light (sky blue)',
  lightRose: 'Light (rose)',
  darkOrange: 'Dark (orange)',
  darkSky: 'Dark (sky blue)',
  darkRose: 'Dark (rose)',
};

export const THEME_ACCENT_SHORT_LABELS: Record<ThemeAccent, string> = {
  blue: 'Blue',
  orange: 'Orange',
  sky: 'Sky',
  rose: 'Rose',
};

/** Rows for the color-palette UI: appearance group × accent columns. */
export const THEME_PALETTE_ROWS: { title: string; modes: readonly ThemeMode[] }[] = [
  { title: 'Light', modes: ['light', 'lightOrange', 'lightSky', 'lightRose'] },
  { title: 'Dark', modes: ['dark', 'darkOrange', 'darkSky', 'darkRose'] },
];
